var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("MonitorLayoutTemplate", {
    attrs: {
      default_value: _vm.default_value,
      table_title: _vm.table_title,
      is_show_chart_dialog: _vm.is_show_chart_dialog
    },
    scopedSlots: _vm._u([
      {
        key: "datetime",
        fn: function() {
          return [
            _c("QpeDatetime", {
              attrs: {
                props_date: _vm.date,
                props_time: _vm.time,
                name: _vm.default_value
              },
              on: {
                "update-time": _vm.update_time,
                "change-parent-date-time": _vm.change_parent_date_time
              }
            })
          ]
        },
        proxy: true
      },
      {
        key: "datetime_interval",
        fn: function() {
          return [
            _c(
              "div",
              { staticStyle: { display: "flex", "align-items": "center" } },
              [
                _c("QpeDatetimeHistory", {
                  on: {
                    set_history_date_list: _vm.set_history_date_list,
                    open_hint_dialog: _vm.open_hint_dialog
                  }
                })
              ],
              1
            )
          ]
        },
        proxy: true
      },
      {
        key: "description",
        fn: function() {
          return [
            _c("SignsCalculator", { attrs: { data: _vm.sign_data } }),
            _vm._v(" "),
            _c("MapDisplaySwitch", {
              attrs: {
                table_id: _vm.default_value,
                table_data: _vm.immutable_table_data
              }
            })
          ]
        },
        proxy: true
      },
      {
        key: "signs",
        fn: function() {
          return [
            _c("MonitorSigns", {
              attrs: {
                data: _vm.sign_data,
                enable_display_tooltip: true,
                generate_tooltop_display_info:
                  _vm.generate_tooltop_display_info_for_signs
              }
            })
          ]
        },
        proxy: true
      },
      {
        key: "data_table",
        fn: function(slot_props) {
          return [
            _c("QpeDatatable", {
              attrs: {
                data: _vm.table_data,
                headers: _vm.header,
                name: _vm.default_value,
                error_text: _vm.error_text,
                search: slot_props.search,
                should_draw_diagram_header: _vm.should_draw_diagram_header,
                enable_table_label: true,
                show_download_doc_btn: true,
                show_download_pdf_btn: _vm.show_download_pdf_btn,
                should_display_info_header_key_value:
                  _vm.should_display_info_header_key_value,
                generate_tooltop_display_info:
                  _vm.generate_tooltop_display_info_for_table,
                should_show_raw_html_header: _vm.should_show_raw_html_header,
                show_footer: false,
                no_data_text: "目前無警示測站",
                is_show_chart_dialog_parent: _vm.is_show_chart_dialog
              },
              on: {
                "update-time": _vm.update_time,
                "change-parent-date-time": _vm.change_parent_date_time,
                "open-chart": _vm.assign_chart_component,
                "update:is_show_chart_dialog_parent": function($event) {
                  _vm.is_show_chart_dialog = $event
                }
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "diagram_dialog",
                    fn: function(ref) {
                      var close_dialog = ref.close_dialog
                      return [
                        _vm.is_show_chart_dialog
                          ? _c("GisChart", {
                              attrs: {
                                id: "belongs_monitor_chart",
                                chart_options: _vm.chart_options,
                                default_variable: _vm.$t("__rainfall.rainfall"),
                                prop_rain_selected: _vm.current_table_header
                              },
                              on: { "close-chart-dialog": close_dialog }
                            })
                          : _vm._e()
                      ]
                    }
                  }
                ],
                null,
                true
              )
            })
          ]
        }
      },
      {
        key: "history_data_table",
        fn: function(slot_props) {
          return [
            _c("QpeDatatableHistory", {
              attrs: {
                name: _vm.default_value,
                search: slot_props.search,
                search_column: slot_props.search_column,
                default_value: _vm.default_value,
                history_date_list: _vm.history_date_list,
                show_download_pdf_btn: _vm.show_download_pdf_btn
              },
              on: { set_history_sign_data: _vm.set_history_sign_data }
            })
          ]
        }
      },
      {
        key: "hint_dialog",
        fn: function() {
          return [
            _c("QpeDialogHistory", {
              attrs: { is_open_dialog: _vm.is_open_dialog },
              on: { close_hint_dialog: _vm.close_hint_dialog }
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }